import { Pipe, PipeTransform } from '@angular/core';
import { formatSecondsToHms } from './format.util';

@Pipe({
    standalone: false,
    name: 'formatSeconds',
    pure: false,
})
export class FormatSecondsPipe implements PipeTransform {
    transform(timeInSeconds: number): string {
        return formatSecondsToHms(timeInSeconds);
    }
}
